export enum AnswerGroupModuleCids {
  Queue = 0,
  HoldQueue = 3,
  Overflow = 26,
  WelcomeMessageSwitch = 32,
  WelcomeMessage = 33,
  CallbackQueueMode = 36,
  CallbackQueue = 39,
  SmsNps = 43,
  CallbackMode = 45,
  CallbackSmsMode = 46,
  CallbackSmsNotification = 49
}
